<template>
  <span class="view-file" :id="field.key">
    <span v-if="field.isArray && fileItems.length > 0" class="view-file-array">
      <span
        v-for="(fileItem, index) in fileItems"
        :key="index"
        class="file-item d-block mb-1"
      >
        <i class="material-icons text-primary">attach_file</i>
        <a
          href="#"
          @click.prevent="openFileRef(fileItem)"
          class="text-primary text-decoration-none"
        >
          {{ getFileName(fileItem) }}
        </a>
      </span>
    </span>
    <span v-else-if="!field.isArray && singleFileRef">
      <i class="material-icons text-primary">attach_file</i>
      <a
        href="#"
        @click.prevent="openFileRef(singleFileRef)"
        class="text-primary text-decoration-none"
      >
        {{ getFileName(singleFileRef) }}
      </a>
    </span>
    <span v-else class="text-muted">{{ $t('No file') }}</span>
  </span>
</template>

<script>
import {
  openFileupload,
  showFileuploadAccessError,
  getFileuploadDisplayName,
} from "@/utils/fileuploadAccess";

/**
 * @param {*} raw
 * @returns {string[]}
 */
function normalizeFileItemsList(raw) {
  if (raw == null || raw === "") return [];
  if (Array.isArray(raw)) {
    return raw
      .map((item) => {
        if (typeof item === "string") return item.trim();
        if (item && typeof item === "object" && item.url) return item.url;
        return null;
      })
      .filter(Boolean);
  }
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (trimmed.startsWith("[")) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) return normalizeFileItemsList(parsed);
      } catch {
        /* single string */
      }
    }
    return [trimmed];
  }
  return [];
}

export default {
  name: "ViewFieldFile",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array],
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resolvedRawValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      if (
        this.field.defaultValue !== undefined &&
        this.field.defaultValue !== null
      ) {
        return this.field.defaultValue;
      }
      return null;
    },
    fileItems() {
      if (!this.field.isArray) return [];
      return normalizeFileItemsList(this.resolvedRawValue);
    },
    singleFileRef() {
      if (this.field.isArray) return null;
      const raw = this.resolvedRawValue;
      if (raw == null || raw === "") return null;
      if (typeof raw === "string") return raw;
      if (raw && typeof raw === "object" && raw.url) return raw.url;
      return null;
    },
  },
  methods: {
    getFileName(ref) {
      const name = getFileuploadDisplayName(
        typeof ref === "string" ? ref : ref?.url || ""
      );
      return name || this.$t("Receipt");
    },
    async openFileRef(ref) {
      if (!ref) return;
      const fileRef = typeof ref === "string" ? ref : ref?.url;
      if (!fileRef) return;
      const result = await openFileupload(fileRef, { t: (k) => this.$t(k) });
      if (!result.ok) {
        showFileuploadAccessError(this, result.errorMessage, {
          title: this.$t("Error accessing file."),
          fileRef,
        });
      }
    },
  },
};
</script>

<style scoped>
.view-file {
  font-weight: 500;
}

.view-file-array .file-item:last-child {
  margin-bottom: 0 !important;
}
</style>
